import auth from './auth.json';
import common from './common.json';
import community from './community.json';
import errors from './errors.json';
import family from './family.json';
import home from './home.json';
import hospitality from './hospitality.json';
import invitations from './invitations.json';
import loyalty from './loyalty.json';
import match from './match.json';
import me from './me.json';
import membership from './membership.json';
import more from './more.json';
import notifications from './notifications.json';
import predict from './predict.json';
import profile from './profile.json';
import roster from './roster.json';
import settings from './settings.json';
import shop from './shop.json';
import tabs from './tabs.json';
import tickets from './tickets.json';
import validation from './validation.json';
import voting from './voting.json';

export default {
  auth,
  common,
  community,
  errors,
  family,
  home,
  hospitality,
  invitations,
  loyalty,
  match,
  me,
  membership,
  more,
  notifications,
  predict,
  profile,
  roster,
  settings,
  shop,
  tabs,
  tickets,
  validation,
  voting,
};
